import { render } from "./LandingInspector.vue?vue&type=template&id=8e4c4bc0&scoped=true&ts=true"
import script from "./LandingInspector.vue?vue&type=script&lang=ts"
export * from "./LandingInspector.vue?vue&type=script&lang=ts"

import "./LandingInspector.vue?vue&type=style&index=0&id=8e4c4bc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e4c4bc0"]])

export default __exports__